import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import LineString from '../LineString';
import Geometry from '../Geometry';
import hasInterface from '../../../../../hasInterface';
import Collection from '../../../../../java/util/Collection';
import LinearRing from '../LinearRing';
import GeometryComponentFilter from '../GeometryComponentFilter';
import ArrayList from '../../../../../java/util/ArrayList';
var LinearComponentExtracter = /*#__PURE__*/function () {
  function LinearComponentExtracter() {
    _classCallCheck(this, LinearComponentExtracter);
    LinearComponentExtracter.constructor_.apply(this, arguments);
  }
  _createClass(LinearComponentExtracter, [{
    key: "filter",
    value: function filter(geom) {
      if (this._isForcedToLineString && geom instanceof LinearRing) {
        var line = geom.getFactory().createLineString(geom.getCoordinateSequence());
        this._lines.add(line);
        return null;
      }
      if (geom instanceof LineString) this._lines.add(geom);
    }
  }, {
    key: "setForceToLineString",
    value: function setForceToLineString(isForcedToLineString) {
      this._isForcedToLineString = isForcedToLineString;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [GeometryComponentFilter];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._lines = null;
      this._isForcedToLineString = false;
      if (arguments.length === 1) {
        var lines = arguments[0];
        this._lines = lines;
      } else if (arguments.length === 2) {
        var _lines = arguments[0],
          isForcedToLineString = arguments[1];
        this._lines = _lines;
        this._isForcedToLineString = isForcedToLineString;
      }
    }
  }, {
    key: "getGeometry",
    value: function getGeometry() {
      if (arguments.length === 1) {
        var geom = arguments[0];
        return geom.getFactory().buildGeometry(LinearComponentExtracter.getLines(geom));
      } else if (arguments.length === 2) {
        var _geom = arguments[0],
          forceToLineString = arguments[1];
        return _geom.getFactory().buildGeometry(LinearComponentExtracter.getLines(_geom, forceToLineString));
      }
    }
  }, {
    key: "getLines",
    value: function getLines() {
      if (arguments.length === 1) {
        var geom = arguments[0];
        return LinearComponentExtracter.getLines(geom, false);
      } else if (arguments.length === 2) {
        if (hasInterface(arguments[0], Collection) && hasInterface(arguments[1], Collection)) {
          var geoms = arguments[0],
            lines = arguments[1];
          for (var i = geoms.iterator(); i.hasNext();) {
            var g = i.next();
            LinearComponentExtracter.getLines(g, lines);
          }
          return lines;
        } else if (arguments[0] instanceof Geometry && typeof arguments[1] === 'boolean') {
          var _geom2 = arguments[0],
            forceToLineString = arguments[1];
          var _lines2 = new ArrayList();
          _geom2.apply(new LinearComponentExtracter(_lines2, forceToLineString));
          return _lines2;
        } else if (arguments[0] instanceof Geometry && hasInterface(arguments[1], Collection)) {
          var _geom3 = arguments[0],
            _lines3 = arguments[1];
          if (_geom3 instanceof LineString) _lines3.add(_geom3);else _geom3.apply(new LinearComponentExtracter(_lines3));
          return _lines3;
        }
      } else if (arguments.length === 3) {
        if (typeof arguments[2] === 'boolean' && hasInterface(arguments[0], Collection) && hasInterface(arguments[1], Collection)) {
          var _geoms = arguments[0],
            _lines4 = arguments[1],
            _forceToLineString = arguments[2];
          for (var _i = _geoms.iterator(); _i.hasNext();) {
            var _g = _i.next();
            LinearComponentExtracter.getLines(_g, _lines4, _forceToLineString);
          }
          return _lines4;
        } else if (typeof arguments[2] === 'boolean' && arguments[0] instanceof Geometry && hasInterface(arguments[1], Collection)) {
          var _geom4 = arguments[0],
            _lines5 = arguments[1],
            _forceToLineString2 = arguments[2];
          _geom4.apply(new LinearComponentExtracter(_lines5, _forceToLineString2));
          return _lines5;
        }
      }
    }
  }]);
  return LinearComponentExtracter;
}();
export { LinearComponentExtracter as default };